import { render, staticRenderFns } from "./dangAn.vue?vue&type=template&id=593ecf1b&scoped=true"
import script from "./dangAn.vue?vue&type=script&lang=js"
export * from "./dangAn.vue?vue&type=script&lang=js"
import style0 from "./dangAn.vue?vue&type=style&index=0&id=593ecf1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ecf1b",
  null
  
)

export default component.exports